import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import {BrowserRouter} from "react-router-dom";
import {FaiControllerProvider} from "./context";
import PerfectScrollbar from "react-perfect-scrollbar";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
      <BrowserRouter>
          <FaiControllerProvider>
              <PerfectScrollbar>
                  <App />
              </PerfectScrollbar>
          </FaiControllerProvider>
      </BrowserRouter>
  </React.StrictMode>
);
